<template>
  <el-dialog custom-class="max-dialog" title="条码管理" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="18">
          <el-col :span="24">
          <el-col :span="3">
            <el-select class="Select" v-model="search.used" placeholder="状态" style="width: 90%" size="mini">
              <el-option  label="全部" value=""></el-option>
              <el-option  label="在库" value="0"></el-option>
              <el-option  label="已出库" value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select class="Select" v-model="search.cangkucode" placeholder="请选择仓库" style="width: 90%"  size="mini">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input placeholder="请选择商品" v-model="search.seedname" style="width: 90%"  clearable @click.native="showGoodDetailSel" @clear="clearSeedCode"  size="mini"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input placeholder="请选择类别" v-model="search.categoryname" style="width: 90%"  clearable @click.native="showCategoryDetailSel" @clear="clearCategory"  size="mini"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="search.storegoodsbarcode" @change="bindGrid" @clear="bindGrid" clearable style="width: 90%" placeholder="请输入条码"  size="mini"></el-input>
          </el-col>
          </el-col>
          <el-col :span="6">
            <span>球S：</span>
            <el-input style="width:70px;" v-model="pack.Y" size="mini">
            </el-input>
            <span>-</span>
            <span>柱C：</span>
            <el-input style="width:70px;" v-model="pack.X" size="mini">
            </el-input>
          </el-col>
          <el-col :span="8">
            <span class="demonstration">有效期</span>
            <el-date-picker style="width:130px" size="mini"
                            v-model="search.begindate" :value-format="'yyyy-MM-dd'"
                            type="date">
            </el-date-picker>
            <span class="demonstration">~</span>
            <el-date-picker style="width:130px" size="mini"
                            v-model="search.enddate" :value-format="'yyyy-MM-dd'"
                            type="date">
            </el-date-picker>
          </el-col>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
        </el-col>
      </el-col>

    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(224)" @sort-change="orderChange"
      size="mini"
      border
      style="width: 100%;">
      <el-table-column  width="60" label="序号" align="center" fixed>
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column prop="seedcode" fixed label="编码"  align="left" header-align="center" width="100" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="seedname" fixed :show-overflow-tooltip="true" label="名称" align="left" header-align="center" width="220">
      </el-table-column>
      <el-table-column prop="packagesize"  width="150" fixed label="规格" align="left" header-align="center" sortable="custom">
        <template slot-scope="scope">
          {{getPackagesize(scope.row.packagesize)}}
        </template>
      </el-table-column>
      <el-table-column  width="140" fixed label="仓库" align="left" header-align="center">
        <template slot-scope="scope">
          {{getCangkuname(scope.row.cangkucode)}}
        </template>
      </el-table-column>
      <el-table-column  prop="storegoodsbarcode" fixed width="120" label="条码" align="left" header-align="center">
      </el-table-column>
      <el-table-column  prop="starttime" width="100" label="批次号" align="left" header-align="center" sortable="custom">
        <template slot-scope="scope">
          {{(scope.row.starttime|| "").substring(0,10)}}
        </template>
      </el-table-column>
      <el-table-column  prop="endtime" width="100" label="有效期" align="left" header-align="center">
        <template slot-scope="scope">
          {{(scope.row.endtime|| "").substring(0,10)}}
        </template>
      </el-table-column>
      <el-table-column  prop="inordernum" width="120" label="入库单" align="left" header-align="center">
      </el-table-column>
      <el-table-column  prop="intime" width="150" label="入库时间" align="left" header-align="center" sortable="custom">
      </el-table-column>
      <el-table-column  prop="outordernum" width="120" label="出库单" align="left" header-align="center">
      </el-table-column>
      <el-table-column  prop="outtime" width="150" label="出库时间" align="left" header-align="center" sortable="custom">
      </el-table-column>
      <el-table-column fixed="right" label="操作" header-align="center" align="left" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
          <el-button size="mini" @click="handlePrint(scope.row)">打印</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <el-dialog
      title="输入" :append-to-body="true"
      :visible.sync="childdialogVisible"
      width="30%" height="300px">
      <div v-if="handletype=='edit'"><span>批次号：</span><el-date-picker style="width:140px" size="mini" v-model="edit.starttime" :value-format="'yyyy-MM-dd'" type="date"></el-date-picker></div>
      <div v-if="handletype=='print'">
      <el-radio-group v-model="edit.status" size="mini">
        <el-radio label="">首行不空</el-radio>
        <el-radio label="1">首行空1格</el-radio>
        <el-radio label="2">首行空2格</el-radio>
      </el-radio-group></div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="childdialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="handleDia">确 定</el-button>
  </span>
    </el-dialog>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
  </el-dialog>
</template>

<script>
  import {listBar,printBar,updateStarttime} from '@/api/set/jxcstoregoodsbar';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'

  export default {
    name: "UniqueCode",
    data() {
      return {
        jxcstoreData: [],
        canshowgoodsel: true,
        childdialogVisible: false,
        handletype: '',
        edit: {
          starttime: '',
          status: '',
          row: {}
        },
        pack: {X: '', Y: ''},
        search: {
          used: '0',
          cangkucode: '',
          storegoodsbarcode: '',
          seedname: '',
          seedcode: '',
          categoryname: '',
          categorycode: '',
          begindate: '',
          enddate: '',
          x: '',
          y: '',
          offset: 0,
          limit: 0,
          sort:'',
          order:''
        },
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        seedcode: '',
        seedname: '',
        cangkucode: '',
        cangkuname: '',
        dialogFormVisible: false,
        goodsbarcode: '',
      }
    },
    methods: {
      getCangkuname(cangkucode) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == cangkucode)
            return this.jxcstoreData[i].cangkuname;
        }
      },
      //清空商品
      clearSeedCode() {
        this.search.seedcode = ""
        this.search.seedname = ""
        this.canshowgoodsel = false
      },
      //清空商品le
      clearCategory() {
        this.search.categorycode = ''
        this.search.categoryname = ''
        this.canshowgoodsel = false
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //显示商品类别选择页面
      showCategoryDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgoodscategorySel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.search.seedcode = row.seedcode
        this.search.seedname = row.seedname
      },
      //选择商品类别之后执行
      afterSelectCategoryCode(row) {
        this.search.categorycode = row.categorycode
        this.search.categoryname = row.categoryname
      },
      show(search, param) {
        this.search.cangkucode = search.cangkucode;
        this.jxcstoreData = param.jxcstoreData;
        this.dialogFormVisible = true
        if (search.seedcode) {
          this.search.seedcode = search.seedcode;
          this.search.seedname = search.seedname;
        }
        this.bindGrid();
      },
      //排序发生改变
      orderChange(column) {
        if (column.order == 'descending') {
          this.search.order = 'desc'
        } else {
          this.search.order = 'asc'
        }
        this.search.sort=column.prop;
        if(this.search.sort=='packagesize'){
          if (column.order == 'descending') {
            this.search.sort = 'y desc,x'
          } else {
            this.search.sort = 'y asc,x'
          }
        }
        this.bindGrid();
      },
      bindGrid() {
        this.search.offset = (this.pagination.currentPage - 1) * this.pagination.pageSize;
        this.search.limit = this.pagination.pageSize;
        this.search.x='';
        this.search.y='';
        if(this.pack.X.trim()||this.pack.Y.trim()) {
          this.search.x = this.pack.X.trim() ? parseFloat(this.pack.X.trim()).toFixed(2) : '%';
          this.search.y = this.pack.Y.trim() ? parseFloat(this.pack.Y.trim()).toFixed(2) : '%';
        }
        listBar(this.search).then(response => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        })
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';
        if (ps.M) {
          return ps.M + '/' + ps.C.replace('/', '');
        }

        return rl + 'S：' + ps.Y + '，C：' + ps.X;
      },
      handlePrint(row) {
        this.handletype='print'
        this.edit.row=row;
        this.childdialogVisible = true;
      },
      handleEdit(row) {
        this.handletype='edit'
        this.edit.row=row;
        this.edit.starttime=row.starttime;
        this.childdialogVisible = true;
      },
      handleDia() {
        if (this.handletype == 'print') {
          printBar(this.edit.row.unitguid, this.edit.status, 'unitguid');
          this.childdialogVisible = false;
        }else {
          if (!this.edit.starttime) {
            this.$message({
              message: '批次号必填！',
              type: 'error'
            })
            return;
          }
          updateStarttime({starttime: this.edit.starttime, unitguid: this.edit.row.unitguid}).then(response => {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
            this.bindGrid();
            this.childdialogVisible = false;
          })
        }
      }
    },
    mounted() {
    },
    components: {
      JxcgooddetailSel,
      JxcgoodscategorySel
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/UniqueCode.vue